export default __webpack_public_path__ + "static/media/check2.8f796ee2.svg";